// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2krZv","errorLogs":"EditorFooter_errorLogs__1lJ6a"};